module.exports = __webpack_public_path__ + "static/media/adra-logo.032d3f57.png";